import { Ticket } from '../../types/ticket';
import { Rule } from '../Rule';
import { RuleContext } from '../RuleContext';

export class CheckIfTheTicketGroupCanBeSoldRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { tickets, event } = context;
    const canBeSold = event?.attributes.showSouldOut.value;

    const ticketGroupsFiltered = tickets.filter((ticket) => (
      ticket.status === 'available' ||
      ticket.status === 'soldout' && canBeSold
    ));

    const filteredTickets = ticketGroupsFiltered.map(({ type }, index, reference) => {
      const filteredTypes = type.filter((ticket) => (
        ticket.status === 'available' ||
        ticket.status === 'soldout' && canBeSold
      ));

      return {
        ...reference[index],
        type : filteredTypes,
      };
    });

    return filteredTickets.filter((ticketGroup) => ticketGroup.type.length > 0);
  }
}
